import PropTypes from "prop-types";
import { Register } from "vino/components";

const Block = ({ attributes }) => {
	return <Register attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
